
<template>

  <div class="atividades-rfilancamentos ml-4 mr-4" >
           
          <b-row>

                                              <b-col cols="1">
                                    <b-form-group class="mb-3 mt-3">
                                      <b-form-input @keyup.enter="loadFuncionario()"  v-model="registro" required placeholder="Nº de RE" ></b-form-input>              
                                    </b-form-group>
                                  </b-col>  
            


                                                          <b-col cols="3" class="mb-3 mt-3">
                          <b-input-group-text>
                            {{ funcionarios.nome ? funcionarios.nome : '-' }}
                          </b-input-group-text>
                        </b-col>    



                                                <b-col cols="3" class="mb-3 mt-3">
                          <b-input-group-text>
                            {{ funcionarios.funcao ? funcionarios.funcao : '-' }}
                          </b-input-group-text>
                        </b-col>       


          </b-row>
    

    
    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>    
    <!--tbl de dados -->
        <b-table small hover striped sticky-header="100%"  :items="itemsFiltered" :fields="fieldsCliFor">                  
        <template slot="cell(actions)" slot-scope="data">
          <b-button  
          @click="putItens(data.item),loadVendaItens()" 

             title="Consultar produto"  size="sm" variant="primary" class="mr-2 mt-2" v-b-modal.ModalComprasFuncionario>                
            <i class="fa fa-pencil"></i>              
          </b-button> 
<!--
          <b-button  @click="putFunc(data.item)"    title="Gerar PDF"  size="sm" variant="warning" class="mr-2 mt-2" v-b-modal.ModalComprasFuncionario>                
            <i class="fa fa-bus"></i>              
          </b-button> 
-->

        </template>
    </b-table>   
    

      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      <div>        
    <b-modal id="ModalComprasFuncionario" centered cancel-title="Fechar"  @cancel="loadCliGrid()"  @close="loadCliGrid()" hide-footer size="xl" title="Itens da compra"  no-close-on-esc no-close-on-backdrop>
          <!-- -->
          <div>

                <!--tbl de dados -->
        <b-table small hover striped sticky-header="100%"  :items="vendaItens" :fields="fieldsVendaItens">                  
        <template slot="cell(actions)" slot-scope="data">
          <b-button  
              @click="putFunc(data.item)"  
         
          title="Consultar itens"  size="sm" variant="primary" class="mr-2 mt-2" v-b-modal.ModalComprasFuncionario>                
            <i class="fa fa-pencil"></i>              
          </b-button> 
<!--
          <b-button  @click="putFunc(data.item)"    title="Gerar PDF"  size="sm" variant="warning" class="mr-2 mt-2" v-b-modal.ModalComprasFuncionario>                
            <i class="fa fa-bus"></i>              
          </b-button> 
-->

        </template>
        </b-table>   

          


            
          </div>
          
        </b-modal>
      </div>
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
  </div>  

</template>


<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import { mapState } from 'vuex' 
import LoadingModal from '../utilitarios/LoadingModal'

export default {

  computed : { ... mapState (['user'],),

      getStyle() {
      return {
        color: this.resultadocnpj.situacao !== 'ATIVA' && this.resultadocnpj.situacao !=null ? 'red' : '', // Fonte vermelha se não for 'ATIVA'
        background: this.resultadocnpj.situacao !== 'ATIVA' && this.resultadocnpj.situacao !=null ? 'yellow' : '', // Background amarelo se não for 'ATIVA'
      };
    },


  itemsFiltered(){
        let valorefu = [];       
        valorefu = this.vendasFuncionarios.filter((item) =>{
          const nome = item.nome || ''; // devido alguns valores retornarem null se faz necessario a substituição para não dar erro no filtro
          const cnpj = item.cnpj || '';          
          return (
             nome.indexOf(this.search) >-1  ||             
             cnpj.indexOf(this.search) >-1 
          );
        });
        return valorefu
        }

  } ,

    name: 'FuncionarioCadastro',    

    data: function() {
      
      return {
          vendaItens:[],
          funcionarios:[],
          funcionario:{},
          empresa:{}, 
          empresas:[],   // [] lista       
          filial:{}, 
          filiais: [],   // [] lista      
          clifors:[],
          clifor:{},          
          ceps:[],
          vendasFuncionario:{},
          vendasFuncionarios:[],
          resultadocnpj:{},
          value_cnpj:'',
          areas:[],
          tipos:[],
          escritorios:[],
          search:'',
          registro:'',
/*
            mode: 'save',
            carregando: false,
            atualizando: false,              
            page: 1,
            limitcarro: 0,
            count: 0,
            valor_empresa:'',                                     
            selected: null,
  */          
            fieldsCliFor: [                
                { key: 'ticket_id', label: 'Ticket', sortable: true },                 
                { key: 'dt_cadastro', label: 'Data ', sortable: true, formatter: (value, key, itemsFiltered) => {
                    return moment(itemsFiltered.dt_cadastro).format('DD/MM/YYYY HH:MM').replace('Data inválida','-') ; }  },                
                { key: 'total', label: 'R$ Valor', sortable: true },                 
                { key: 'tipo', label: 'Forma Pagto', sortable: true },                       
                { key: 're', label: 'Registro', sortable: true },
                { key: 'nome', label: 'Nome', sortable: true },
                { key: 'funcao', label: 'Função', sortable: true },                
                { key: 'actions', label: 'Ações' },                
            ],
                        fieldsVendaItens: [                
                { key: 'id', label: 'Ticket', sortable: true },                                
                { key: 'codigo_erp', label: 'Código', sortable: true },
                { key: 'descricao', label: 'Descrição', sortable: true },                       
                { key: 'quantidade', label: 'Quantidade', sortable: true },                 
                { key: 'valor_unitario', label: 'R$ Unitário', sortable: true },
                { key: 'valor_total', label: 'R$ Total', sortable: true },                                
            ]
        }        
    },

    components: {
        Multiselect, LoadingModal
    },

    methods: {
            async loadFuncionario() { 
            let corpo = {                             
            "registro": `${this.registro}`,
            "id_empresa": `${this.user.id_empresa}`
            };             
          const url = `${baseApiUrl}/jb/folha/funcionario/listagem`
          axios.post(url,corpo)
              .then(res => { this.funcionarios = res.data })    
              this.reset()
              this.loadCliGrid()              
//              this.loadNovoNroTicket()         
      },  

      handleOk(bvModalEvent) {
        // Prevent modal from closing
        bvModalEvent.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },

        
      async loadCliGrid() {  
          let corpo = {    
            "empresa_id": `${this.user.id_empresa}`,
            "registro": `${this.registro}`,
            "filtro": 'vendafuncionario'
          };
          const url = await`${baseApiUrl}/sambaiba/cf7/produtocad`
          axios.post(url,corpo)
               .then(res => {this.vendasFuncionarios = res.data})         
              .catch(showError)                                
      }, 

      
      putItens(vendasFuncionarios) {            
            this.vendasFuncionario = { ...vendasFuncionarios}
            
      },

      async loadVendaItens() {  
          let corpo = {    
            "empresa_id": `${this.user.id_empresa}`,
            "ticket_id": `${this.vendasFuncionario.ticket_id}`,
            "filtro": 'vendaItens'
          };
          const url = await`${baseApiUrl}/sambaiba/cf7/produtocad`
          axios.post(url,corpo)
               .then(res => {this.vendaItens = res.data})         
              .catch(showError)                                
      }, 
      
      reset() {                  
            this.vendasFuncionarios = []                     
      },      
    },

    watch: {
      page() {
        this.loadVeiculos()
      }
    },

    mounted() {  
    //  this.loadEmpresas()
    //  this.loadArea()
    //  this.loadTipo()      
     // this.loadEscritório()
      
      /*
      this.loadFiliais()
      this.loadVeiculos() 
      this.loadFabricanteChassi()            
      this.loadModeloChassi()
      this.loadcliforStatus()
      this.loadCarroceriaFabricante()
      this.loadCarroceriaModelo()     
      this.loadTipoFrota()
      this.loadLote()
      */

      
    },
}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>

#selecaostatusx{
    font-size: 0.7em;      
}

</style>
